import { ChangeDetectionStrategy, Component, computed, ViewEncapsulation } from '@angular/core';
import { SpecialComponent } from '@src/suite/common/controls/special/special';
import { selectTranslatedKey } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { I18nKeys } from '@src/suite/common/utils/i18n.default';

import { ComboBoxComponent } from '../../combo-box/combo-box';
import { TextFieldCurrencyComponent } from '../../text-field/text-field-currency/text-field-currency';

@Component({
    selector: 'st-special-cost',
    imports: [ComboBoxComponent, TextFieldCurrencyComponent],
    templateUrl: './special-cost.html',
    styleUrl: './special-cost.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-special-cost',
    },
})
export class SpecialCostComponent extends SpecialComponent {
    readonly costColumnLabel = computed(() => {
        return this.store.selectSignal(selectTranslatedKey(I18nKeys.PSTWebCostColumnLabel))();
    });

    readonly costTypeColumnLabel = computed(() => {
        return this.store.selectSignal(selectTranslatedKey(I18nKeys.PSTWebCostTypeColumnLabel))();
    });

    public calculateEditable(i: number): boolean {
        return !this.internalValue()?.get(i, 0) || !!this.disabled();
    }
}
